import { parseBackendData, isValidBackend, BackendData } from "../../Common/Utils/backendDataParser";
import { ClientOptions, SelectClient } from "../../Common/LocalStorage";
import { getAppSettings } from "./localStorageHelper";
import { User } from "../../@types/user";


export function getBackendDataListIDM(user: User): BackendData[] {
  let backendDataList: BackendData[] = [];

  const backendValue: string[] | string = user.profile['backend'] ? user.profile['backend'] : [];

  if (Array.isArray(backendValue)) {
    backendDataList = backendValue
      .map(backendString => parseBackendData(backendString))
      .filter(backendData => isValidBackend(backendData));
  }
  else {
    const backendData = parseBackendData(backendValue);

    if (isValidBackend(backendData)) {
      backendDataList.push(backendData);
    }
  }

  return backendDataList;
};

export async function getBackendDataListAzureB2C() {
  const appSettings = getAppSettings();
  const headers = {
    'AuthMethod': appSettings.authMethod,
    "HandymanApiUrl": appSettings.handymanApiUrl!,
  }
  try {
    let backendDataList: BackendData[] = [];
    const response = await fetch('userInfo/getBackendDataList', { headers });
    backendDataList = await response.json();

    return backendDataList;
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export function setClientOptions(backendDataList: BackendData[]) {
  if (backendDataList && backendDataList.length > 0) {
    //Set client options
    ClientOptions(backendDataList, 'clientOptions');

    const backendLocalStorageValue = localStorage.getItem('selectedClient');

    if (!backendLocalStorageValue) {
      //Select default value if its unset
      SelectClient(backendDataList[0], 'selectedClient');

      return backendDataList[0];
    }
    else {
      const selectedClient: BackendData = JSON.parse(backendLocalStorageValue);

      const selectedClientInOptions = backendDataList.find(backend => backend.name === selectedClient.name);

      if (!selectedClientInOptions) {
        SelectClient(backendDataList[0], 'selectedClient');

        return backendDataList[0];
      }

      return selectedClient;
    }
  }
  else {
    //Clear client options and selected client value from the storage
    ClientOptions([], 'clientOptions');
    SelectClient('', 'selectedClient');
    return undefined;
  }
};